export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1628592102751-ba83b0314276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODkyOTc3NzB8MA&ixlib=rb-4.1.0&q=85",
  dublinGeorgian: "https://images.unsplash.com/photo-1548236747-4ff1145a4864?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6ODl8MHwxfHNlYXJjaHwxfHxkdWJsaW4lMjBjaXR5c2NhcGUlMjBldXJvcGV8ZW58MHx8fHwxNzg5Mjk3NzcwfDA&ixlib=rb-4.1.0&q=85",
  dublinAerial: "https://images.unsplash.com/photo-1571931236586-8f519799d66b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6ODl8MHwxfHNlYXJjaHwyfHxkdWJsaW4lMjBjaXR5c2NhcGUlMjBldXJvcGV8ZW58MHx8fHwxNzg5Mjk3NzcwfDA&ixlib=rb-4.1.0&q=85",
  dublinCity: "https://images.unsplash.com/photo-1584958416995-614bafcc67f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6ODl8MHwxfHNlYXJjaHw0fHxkdWJsaW4lMjBjaXR5c2NhcGUlMjBldXJvcGV8ZW58MHx8fHwxNzg5Mjk3NzcwfDA&ixlib=rb-4.1.0&q=85",
  interiorDining: "https://images.pexels.com/photos/6585598/pexels-photo-6585598.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  livingRoom: "https://images.unsplash.com/photo-1666282167632-c613fbeb163c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcGFydG1lbnQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODkyOTc3NzB8MA&ixlib=rb-4.1.0&q=85",
  founder: "/founder.webp",
};

export const SERVICES = [
  {
    title: "Revenue & Pricing",
    desc: "Dynamic pricing and ongoing optimisation designed to maximise occupancy and revenue — driven by live market demand, not guesswork.",
    detail: "Nightly rates are adjusted continuously against Dublin demand, seasonality, events and competitor performance. Your property is priced to earn, not simply to fill the calendar.",
    icon: "TrendingUp",
  },
  {
    title: "Listing Management",
    desc: "Professional listing creation, optimisation, photography coordination and ongoing improvements across Airbnb and leading channels.",
    detail: "We build a listing that converts: professional photography coordination, considered copy, the right channels, and continuous refinement based on real booking data.",
    icon: "LayoutList",
  },
  {
    title: "Guest Management",
    desc: "Fast, professional communication from first enquiry through checkout — vetting, questions, issues and reviews all handled.",
    detail: "Guests get prompt, polished responses at any hour. You never see a message, chase a review, or resolve a late-night issue again.",
    icon: "MessagesSquare",
  },
  {
    title: "Cleaning & Linen",
    desc: "Reliable turnover management, hotel-standard cleaning and fresh linen between every stay.",
    detail: "Trusted cleaning partners, quality-checked turnovers, managed linen and restocked essentials — so every guest arrives to a property that feels prepared, not just cleaned.",
    icon: "Sparkles",
  },
  {
    title: "Maintenance",
    desc: "Coordination of repairs, issues and ongoing property upkeep through trusted local contractors.",
    detail: "Small issues are resolved before they become reviews. Larger works are coordinated with your approval, using contractors we already trust.",
    icon: "Wrench",
  },
  {
    title: "Property Operations",
    desc: "Bookings, payments, supplies, check-ins and the hundred small details — handled so the owner doesn't have to.",
    detail: "Check-in coordination, booking administration, supplies and essentials, issue resolution and ongoing oversight. The day-to-day simply disappears from your desk.",
    icon: "ClipboardCheck",
  },
];

export const PAINS = [
  "Responding to guest messages at all hours",
  "Constantly adjusting pricing to stay competitive",
  "Coordinating cleaners between every stay",
  "Chasing maintenance issues and contractors",
  "Managing check-ins, checkouts and key handovers",
  "Handling cancellations and booking enquiries",
  "Wondering whether the property is being looked after",
];

export const DIFFERENCE = [
  {
    title: "Hands-off ownership",
    desc: "Once your property is operational, FieldGreen handles the day-to-day. Owners typically check their monthly statement — and little else.",
  },
  {
    title: "Revenue focused",
    desc: "Pricing and property strategy are based on market demand, seasonality and Dublin events — not simply filling the calendar at any rate.",
  },
  {
    title: "Local expertise",
    desc: "We operate in Dublin because we know Dublin — its neighbourhoods, its demand patterns, its guests. That local knowledge shows up in performance.",
  },
  {
    title: "Technology + human service",
    desc: "Modern pricing and property-management technology, with human oversight on every booking, guest and turnover.",
  },
  {
    title: "One point of contact",
    desc: "No juggling cleaners, contractors and guest messages. One team, one point of contact, one monthly statement.",
  },
];

export const STEPS = [
  {
    num: "01",
    title: "Tell us about your property",
    desc: "Submit your property details — location, type, bedrooms and current situation. It takes about two minutes.",
  },
  {
    num: "02",
    title: "We assess the opportunity",
    desc: "We review the property, its location and realistic short-term rental performance, then share an honest assessment.",
  },
  {
    num: "03",
    title: "We prepare and launch",
    desc: "We help get the property guest-ready, create and optimise the listing, and establish the pricing and operating strategy.",
  },
  {
    num: "04",
    title: "We manage everything",
    desc: "Guests, bookings, pricing, cleaning, maintenance and day-to-day operations — all handled by FieldGreen.",
  },
];

export const WHO = [
  {
    title: "Already an Airbnb host",
    desc: "You know the model works — you're just tired of running it. Hand over the day-to-day and keep the returns.",
  },
  {
    title: "Dublin landlord",
    desc: "You're in a long-term tenancy and wondering whether your property could perform better as a short-term rental. We'll give you a straight answer.",
  },
  {
    title: "Hands-off property owner",
    desc: "You live outside Dublin, or simply don't have the time. You want a professional operator managing the entire operation.",
  },
];

export const FAQS = [
  {
    q: "How much could my property earn?",
    a: "It depends on location, size, finish and seasonality. Rather than quote generic figures, we assess your specific property against live Dublin market data and give you a realistic revenue range. Request a property assessment and we'll share an honest view — no inflated promises.",
    cat: "Revenue & Fees",
  },
  {
    q: "What properties do you manage?",
    a: "Well-presented apartments and houses across Dublin that are suited to short stays — from city-centre apartments to family homes in the south Dublin suburbs. Every property is assessed individually before we take it on.",
    cat: "Your Property",
  },
  {
    q: "Do you manage Airbnb listings?",
    a: "Yes — end to end. We create, optimise and manage your listing on Airbnb and other leading short-term rental channels, including photography coordination, copy, pricing and calendar management.",
    cat: "Your Property",
  },
  {
    q: "Do I need to furnish or stage my property?",
    a: "Properties do need to be furnished to a guest-ready standard. If yours isn't there yet, we can advise on exactly what's needed and coordinate the setup as part of onboarding — without overspending on things guests don't notice.",
    cat: "Your Property",
  },
  {
    q: "Who handles cleaning?",
    a: "We do. Every turnover is managed by professional cleaning partners with hotel-standard checklists, fresh linen and restocked essentials — quality-checked so every guest arrives to a property that feels prepared.",
    cat: "Day-to-Day",
  },
  {
    q: "Who deals with maintenance?",
    a: "FieldGreen coordinates all repairs and upkeep through trusted local contractors. Day-to-day issues are resolved immediately; larger works are always discussed with you first.",
    cat: "Day-to-Day",
  },
  {
    q: "Who communicates with guests?",
    a: "We handle all guest communication — from the first enquiry and vetting, through check-in instructions, in-stay questions and checkout, to reviews. Fast, professional and around the clock.",
    cat: "Day-to-Day",
  },
  {
    q: "How does the management fee work?",
    a: "Simple: 15% + VAT of rental revenue. No complicated packages, no hidden extras. Because our fee is tied to performance, we're commercially aligned with you from day one.",
    cat: "Revenue & Fees",
  },
  {
    q: "Can I still use the property myself?",
    a: "Yes. You can block out dates for your own use — it's your property. Many owners reserve weeks for family visits or personal stays and let the property perform the rest of the year.",
    cat: "Day-to-Day",
  },
  {
    q: "Do you manage properties outside Dublin?",
    a: "Our focus is Dublin, where our local knowledge and operating partners are strongest. If your property is just outside the city, get in touch and we'll tell you honestly whether we can help.",
    cat: "Suitability",
  },
  {
    q: "Is short-term letting suitable for my property?",
    a: "Not every property is a good fit, and suitability depends on location, layout, building rules and current regulations. As part of your assessment we'll give you a straight answer — including when we think long-term letting is the better option.",
    cat: "Suitability",
  },
  {
    q: "What happens if my property isn't suitable?",
    a: "We'll tell you directly, explain why, and where possible suggest alternatives. We'd rather turn a property down than manage it badly.",
    cat: "Suitability",
  },
];

export const FAQ_DISCLAIMER =
  "Owners are responsible for ensuring their property is legally eligible for short-term letting under current regulations, including planning requirements that may apply in rent pressure zones. FieldGreen can discuss the operational considerations with you, but does not provide legal advice.";

export const MARQUEE_ITEMS = [
  "Dublin",
  "Short-Term Rental Management",
  "Corporate Stays 21+ Days",
  "Revenue Optimisation",
  "Guest Management",
  "Cleaning & Linen",
  "Local Expertise",
  "Hands-Off Ownership",
];

export const ENQUIRY_TYPES = [
  { value: "short_term", label: "Short-term rental management" },
  { value: "corporate", label: "Corporate stay enquiry (21+ days)" },
  { value: "unsure", label: "Both / not sure yet" },
];

export const PROPERTY_TYPES = ["Apartment", "House", "Studio", "Penthouse", "Other"];
export const BEDROOMS = ["Studio", "1", "2", "3", "4+"];
export const RENTAL_SITUATIONS = [
  "Long-term tenancy at the moment",
  "Already on Airbnb / short-term",
  "Vacant or newly acquired",
  "Owner-occupied",
  "Other",
];

export const UPLISTING_BASE = "https://fieldgreen.bookeddirectly.host";

export const PROPERTIES = [
  {
    id: "swords-3bed",
    name: "Fully Renovated 3-Bed Home | Swords | Near Airport",
    title: "Fully Renovated 3-Bed Home · Near Airport",
    area: "Swords, Co. Dublin",
    type: "House",
    beds: 3,
    baths: 2,
    sleeps: 5,
    price: 183,
    url: `${UPLISTING_BASE}/property/4f684f`,
    photo: "https://djts5lg061pqs.cloudfront.net/50e8f372-d447-42c9-a5de-1b7a9b42f35d.jpg?width=1200",
    blurb: "A bright, fully renovated family home minutes from Dublin Airport — spacious living and dining, a fully equipped kitchen, high-speed Wi-Fi and easy bus links into the city centre.",
    tags: ["Near Dublin Airport", "Self check-in", "High-speed Wi-Fi"],
  },
  {
    id: "citywest-2bed",
    name: "Modern 2-Bed Near Luas & Dublin Mountains",
    title: "Modern 2-Bed · Near Luas & Dublin Mountains",
    area: "Citywest, Dublin 24",
    type: "Apartment",
    beds: 2,
    baths: 2,
    sleeps: 4,
    price: 179,
    url: `${UPLISTING_BASE}/property/cb2376`,
    photo: "https://djts5lg061pqs.cloudfront.net/9ff60e7b-932b-4e29-b4a2-5156daa87ee9.jpg?width=1200",
    blurb: "A bright, open-plan apartment with a dedicated workspace, free parking and lift access — walking distance to the Luas, Citywest Business Campus and the M50.",
    tags: ["Free parking", "Dedicated workspace", "Beside the Luas"],
  },
  {
    id: "ballsbridge-1bed",
    name: "1-Bed + Sofa Bed | Dublin 4 | Excellent Location",
    title: "1-Bed + Sofa Bed · Dublin 4",
    area: "Ballsbridge, Dublin 4",
    type: "Apartment",
    beds: 1,
    baths: 1,
    sleeps: 3,
    price: 240,
    url: `${UPLISTING_BASE}/property/da65e5`,
    photo: "https://djts5lg061pqs.cloudfront.net/f8ec4881-9d07-4c36-80f4-3c708979bb91.jpg?width=1200",
    blurb: "A comfortable apartment in one of Dublin's most sought-after neighbourhoods — ideal for couples, solo travellers and longer stays close to the city centre.",
    tags: ["Dublin 4", "Sofa bed", "Great for longer stays"],
  },
];

export const AREAS = [
  {
    slug: "airbnb-management-ballsbridge",
    name: "Ballsbridge",
    tag: "Dublin 4",
    pageTitle: "Airbnb Management Ballsbridge | FieldGreen Property Management",
    metaDesc: "Professional Airbnb and short-term rental management in Ballsbridge, Dublin 4. Pricing, guests, cleaning and maintenance handled — see what your Ballsbridge property could earn.",
    headline: ["Your Ballsbridge property,", "working harder for you."],
    intro: "Ballsbridge is one of Dublin's strongest short-term rental areas — an embassy-belt postcode with year-round demand from professionals, event visitors and corporate guests who want a quieter, premium base minutes from the city centre.",
    drivers: [
      { t: "RDS and Aviva on the doorstep", d: "Exhibitions, concerts and international rugby fill the calendar — and fill well-positioned properties at strong nightly rates." },
      { t: "Embassy and corporate demand", d: "Diplomatic staff, visiting delegations and professionals on assignment need quality medium-term accommodation in Dublin 4." },
      { t: "A genuine postcode premium", d: "Guests pay more for D4. Well-presented Ballsbridge apartments consistently command higher nightly rates than comparable areas." },
      { t: "Thin local hotel stock", d: "Limited hotel options in the immediate area push demand toward professionally managed short-term rentals." },
    ],
    types: "Period conversions, mews houses and modern one- and two-bedroom apartments all perform well here — particularly properties finished to a professional, hotel-adjacent standard.",
    relatedProperty: "da65e5",
  },
  {
    slug: "airbnb-management-grand-canal-dock",
    name: "Grand Canal Dock",
    tag: "Dublin 2",
    pageTitle: "Airbnb Management Grand Canal Dock | FieldGreen Property Management",
    metaDesc: "Short-term rental and Airbnb management in Grand Canal Dock, Dublin 2. Corporate-stay demand from the Silicon Docks, dynamic pricing and full management for landlords.",
    headline: ["Silicon Docks demand,", "professionally captured."],
    intro: "Grand Canal Dock sits at the centre of Dublin's tech economy. With global headquarters on every side, the area delivers some of the most reliable year-round short-stay and corporate-stay demand in the city — strong midweek occupancy included.",
    drivers: [
      { t: "Tech HQs on every side", d: "Google, Meta, Accenture and dozens more bring a constant flow of business travellers, new hires and visiting teams." },
      { t: "Dublin's corporate stay heartland", d: "Relocations and project placements drive 21+ day bookings — fewer turnovers, vetted professional guests, dependable revenue." },
      { t: "Year-round midweek occupancy", d: "Business demand keeps weekdays full when leisure areas go quiet — the difference between a good calendar and a great one." },
      { t: "Events and entertainment", d: "The Bord Gáis Energy Theatre and the wider docklands calendar add leisure demand on top of the corporate base." },
    ],
    types: "Modern one- and two-bedroom apartments in managed developments are the sweet spot here — lift access, parking and workspace-friendly layouts all command a premium with corporate guests.",
    relatedProperty: null,
  },
  {
    slug: "airbnb-management-swords",
    name: "Swords",
    tag: "North County Dublin",
    pageTitle: "Airbnb Management Swords | FieldGreen Property Management",
    metaDesc: "Airbnb and short-term rental management in Swords, Co. Dublin. Airport-adjacent demand, family and group stays, full management — see what your Swords property could earn.",
    headline: ["Airport-adjacent demand,", "all year round."],
    intro: "Swords is one of the most consistently booked areas we manage in. Minutes from Dublin Airport, it attracts early-flight travellers, families, airline crew and visiting relatives — demand that doesn't depend on the city-centre tourist season.",
    drivers: [
      { t: "Dublin Airport minutes away", d: "Early departures and late arrivals create reliable, year-round bookings that city-centre properties simply don't see." },
      { t: "Family and group stays", d: "Houses with space, parking and gardens attract longer family bookings — higher value per reservation, calmer calendars." },
      { t: "Parking and practicality", d: "Free parking and easy motorway access make Swords a practical base for guests exploring Dublin and the east coast by car." },
      { t: "Value alternative to the centre", d: "Guests priced out of Dublin 2 look north — well-presented Swords homes capture that demand at healthy rates." },
    ],
    types: "Three- and four-bedroom family houses perform exceptionally well here — exactly the profile of our Swords property, which earned its owner €5,800 in August against a €3,000 long-term rent.",
    relatedProperty: "4f684f",
    caseStudy: true,
  },
];
